module.exports = __webpack_public_path__ + "media/images/pages/secondary-toolkit/i_belong_students-860ff4c7712805d152087d68c3af71bd.jpeg";